<template>
    <div>
        <b-row>
            <b-col cols="12">
                <b-overlay :show="isLoading">
                    <b-form>
                        <b-row>
                            <b-col cols="12">
                                <h3 v-if="isEdit">Edit Supplier <b-button size="sm" class="thin-button" @click="addNew" variant="primary">New Supplier</b-button></h3>
                                <h3 v-else>Add New Supplier</h3>
                            </b-col>
                        </b-row>

                        <b-row class="mb-3">
                            <b-col cols="6">
                                <label for="">Company Name</label>
                                <b-form-input v-model="form_data.company_name"></b-form-input>
                            </b-col>
                            <b-col cols="6">
                                <label for="">Company Email</label>
                                <b-form-input v-model="form_data.company_email"></b-form-input>
                            </b-col>
                        </b-row>

                        <b-row class="mb-3">
                            <b-col cols="12">
                                <label for="">Company Address</label>
                                <b-form-textarea v-model="form_data.company_address"></b-form-textarea>
                            </b-col>
                        </b-row>

                        <b-row class="mb-3">
                            <b-col cols="6">
                                <label for="">Contact Number</label>
                                <b-form-input v-model="form_data.tel_no"></b-form-input>
                            </b-col>
                            <b-col cols="6">
                                <label for="">Fax Number</label>
                                <b-form-input v-model="form_data.fax_no"></b-form-input>
                            </b-col>
                        </b-row>

                        <b-row class="mb-3">
                            <b-col cols="12">
                                <label for="">Contact Person</label>
                                <b-form-input v-model="form_data.contact_person"></b-form-input>
                            </b-col>
                        </b-row>

                        <b-row class="mb-3">
                            <b-col cols="12">
                                <label for="">Supplier Activity Description</label>
                                <b-form-input v-model="form_data.activity_desc"></b-form-input>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-overlay>
            </b-col>
        </b-row>
        <b-button class="w-100" variant="primary" @click="saveSupplier">Save</b-button>
    </div>
</template>

<script>
import { facilityAdminMethods, facilityAdminState } from '@/state/helpers'
import _ from 'lodash';
export default {
    data:() => ({
        isLoading: false,
        isEdit: false,
        editData: null,
        form_data:{
            id: -1,
            company_name: '',
            company_address: '',
            tel_no: '',
            fax_no: '',
            company_email: '',
            contact_person: '',
            activity_desc: '',
        },
        has_form_loaded: false,
    }),
    computed:{
        ...facilityAdminState
    },
    methods:{
        ...facilityAdminMethods,
        updateFormData(newData){
            this.form_data = newData.form_data;
        },
        saveSupplier(){
            if(this.isEdit){
                this.form_data.id = this.editData.id;
            }
            else{
                this.form_data.id = -1;
            }
            this.isLoading = true;
            this.saveClientSupplier(this.form_data)
            .then(()=>{
                this.loadClientSuppliers()
                .then(()=>{
                    this.isLoading = false;
                })
                this.addNew();
            })
            .catch(()=>{
                this.isLoading = false;
            })
        },
        editSupplier(id){
            let index = _.findIndex(this.client_suppliers, {id : id});
            if(index != -1){
                this.isEdit = true;
                this.editData = this.client_suppliers[index];

                this.form_data.company_name = this.editData.company_name;
                this.form_data.company_address = this.editData.company_address;
                this.form_data.tel_no = this.editData.tel_no;
                this.form_data.fax_no = this.editData.fax_no;
                this.form_data.company_email = this.editData.company_email;
                this.form_data.contact_person = this.editData.contact_person;
                this.form_data.activity_desc = this.editData.activity_description;
            }
            else{
                this.isEdit = false;
            }
        },
        addNew(){
            //* Clear form input and other related vars
            this.isEdit = false;
            this.form_data = {
                company_name: '',
                company_address: '',
                tel_no: '',
                fax_no: '',
                company_email: '',
                contact_person: '',
                activity_desc: '',
            }

            //* Clear table selection css when adding a new item
            /* eslint-disable-next-line */
            let table = $$('suppliersTable');
            if(table != undefined){
                table.clearSelection();
            }
        }
    },
    mounted(){
        this.$eventHub.$on('editSupplier', this.editSupplier);
    },
    beforeDestroy(){
        this.$eventHub.$off('editSupplier');
    }
}
</script>

<style>

</style>